/**
 * platform/ — detección de plataforma compartida.
 *
 * Única fuente de verdad para saber si el iframe corre dentro del checkout web
 * (desktop) o dentro de la app nativa. Se resuelve una vez al cargar el módulo
 * a partir de `?source=desktop` (el parámetro no cambia durante la vida del iframe):
 *
 *   import { isDesktop } from '../../platform';
 *   {isDesktop ? <A /> : <B />}
 */
import { readEmbedSource } from '../browser/embedSource';

/** `true` cuando el iframe lo embebe el checkout web (`?source=desktop`). */
export const isDesktop: boolean =
  typeof window !== 'undefined' && readEmbedSource(window.location.search) === 'desktop';

/** `true` cuando el iframe lo embebe la app nativa (sin `?source=desktop`). */
export const isApp: boolean = !isDesktop;
